<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.04618 8.86122L11.4372 16.2521C11.747 16.5616 12.2484 16.5616 12.5581 16.2521L19.9491 8.86122C20.2581 8.55201 20.2581 8.04992 19.9491 7.7407C19.6394 7.43149 19.1372 7.43149 18.8282 7.7407L11.9981 14.5713L5.16708 7.7407C4.85811 7.43149 4.35593 7.43149 4.04618 7.7407C3.73721 8.04992 3.73721 8.55201 4.04618 8.86122Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'Dropdown'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
